import cloneDeep from 'clone-deep'
import { productTypeOptions, transactionTypeOptions } from 'config'
import { FeeWorkSheet } from 'pages/Loan/ClosingScreen/FeeWorkSheet'
import { useEffect, useState } from 'react'
import { getClosingCostTemplate, submitClosingCostTemplate } from 'services'
import { RenderInput } from 'utils/RenderInput'

export const ClosingCostTemplate = () => {
  const [productType, setProductType] = useState<string>('')
  const [transactionType, setTransactionType] = useState<string>('')
  const [templateNo, setTemplateNo] = useState<number | null>(null)
  const [template, setTemplate] = useState<Record<string, any>>({})

  useEffect(() => {
    if (!productType || !transactionType) {
      setTemplateNo(null)
      return
    }
    getClosingCostTemplate(productType, transactionType).then((res) => {
      setTemplateNo(res.id)
      setTemplate(res)
    })
  }, [productType, transactionType])

  const onChange = async (key: string, value: any) => {
    if (!templateNo) return
    try {
      const newTemplate = cloneDeep(template)
      newTemplate[key] = value
      setTemplate(newTemplate)
      await submitClosingCostTemplate(templateNo, { [key]: value })
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div className="relative">
      <h2 className="text-2xl font-bold flex items-center mb-3">Closing Cost Templates</h2>
      <div className="flex flex-wrap justify-between mb-3">
        <div className="flex gap-2">
          <RenderInput
            input={{
              inputType: 'select',
              options: productTypeOptions,
              value: productType,
              title: 'Product Type',
              hasDefaultOption: true,
            }}
            Key="productType"
            onChange={(_: string, value: any) => setProductType(value)}
          />
          <RenderInput
            input={{
              inputType: 'select',
              options: transactionTypeOptions,
              value: transactionType,
              title: 'Transaction Type',
              hasDefaultOption: true,
            }}
            Key="transactionType"
            onChange={(_: string, value: any) => setTransactionType(value)}
          />
        </div>
        {templateNo && (
          <RenderInput
            input={{
              inputType: 'toggle',
              value: template.isActivate,
              title: 'Activate',
            }}
            Key="isActivate"
            onChange={(key: string, value: any) => onChange(key, value)}
          />
        )}
      </div>
      {templateNo && <FeeWorkSheet templateNo={templateNo} />}
    </div>
  )
}
